<template>
  <div class="app">
    <div class="app-header">
      <div class="header-title">用户列表</div>
      <div class="header-view">
        <Button type="success" style="margin-left: 10px" @click="add_model = true"
          >添加</Button
        >
      </div>
    </div>
    <!-- 表格 -->
    <Table
      :columns="columns"
      :data="dataList"
      :loading="loading"
      :total="TotalCount"
      @handleRowClick="handleRowClick"
      @onPageChange="onPageChange"
      @onPageSizeChange="onPageSizeChange"
    ></Table>

    <!-- 新增 -->
    <AddUserModel
      :isShow="add_model"
      :details="details"
      @on-change="addChange"
    ></AddUserModel>

    <!-- 编辑 -->
    <EditUserModel
      :isShow="edit_model"
      :details="edit_details"
      @on-change="editChange"
    ></EditUserModel>
    
  </div>
</template>

<script>
import { LoaderUserList, AddUser, UpdateUser, DeleteUser } from "@/api/url_api.js";
import defaultData from "./columns.js";
import Table from "@/components/VTable";
import AddUserModel from "./add_user_model.vue";
import EditUserModel from "./edit_user_model.vue";
import Cookies from "js-cookie";
export default {
  components: {
    Table,
    AddUserModel,
    EditUserModel,
  },
  data() {
    return {
      dataList: [],
      loading: false,
      pageIndex: 1,
      pageSize: 15,
      TotalCount: 0,

      groupCode: Cookies.get('GroupCode'),
      IsSuperAdmin: Cookies.get('IsSuperAdmin'),

      add_model: false,
      details: {},

      edit_model: false,
      edit_details: {},
    };
  },
  computed: {
    columns() {
      return defaultData.columns(this);
    },
  },
  mounted() {
    let _this = this;
    // 获取用户列表
    _this.getLoaderUserList();
  },
  methods: {
    getLoaderUserList() {
      let _this = this;
      let groupCode = _this.IsSuperAdmin == '1' ? '' : `&groupCode=${_this.groupCode}`;
      LoaderUserList(
        `?pageIndex=${_this.pageIndex}&pageSize=${_this.pageSize}` + groupCode
      )
        .then((res) => {
          if (res.Success) {
            _this.dataList = res.Data;
            _this.TotalCount = res.TotalCount;
          } else {
            _this.$Message["error"]({
              background: true,
              content: res.Message,
            });
          }
        })
        .catch((err) => {
          if (err.data.Code == -9 || err.data.Message == '缺少token' || err.data.Message == '未找到身份认证信息，请重新登录') {
            _this.$router.push({
              name: "login",
            });
          } else {
            _this.$Message["error"]({
              background: true,
              content: err.data.Message,
            });
          }
        });
    },

    // 添加回调
    addChange(stateMsg, value) {
      let _this = this;
      _this.add_model = stateMsg;

      if (value) {
        AddUser(value).then(res => {
          if (res.Success) {
            _this.$Message['success']({
              background: true,
              content: res.Message
            });
            // 获取用户列表
            _this.getLoaderUserList();
            _this.details = {};
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        }).catch(err => {
          _this.$Message['error']({
            background: true,
            content: err.response.Message
          });
        })
      }
    },

    // 编辑事件
    paymentClick(row, index) {
      let _this = this;
      _this.edit_details = {...row};
      _this.edit_model = true;
    },

    // 编辑回调
    editChange(stateMsg, value) {
      let _this = this;
      _this.edit_model = stateMsg;
      if (value) {
        UpdateUser(value).then(res => {
          if (res.Success) {
            _this.$Message['success']({
              background: true,
              content: res.Message
            });
            // 获取用户列表
            _this.getLoaderUserList();
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        }).catch(err => {
          _this.$Message['error']({
            background: true,
            content: err.response.Message
          });
        })
      }
    },

    // 删除回调
    deleteClick(row, index) {
      let _this = this;
      _this.$Modal.confirm({
        title: '提示',
        content: `<p>是否禁用${row.LoginCode}</p>`,
        onOk: () => {
          DeleteUser(`/${row.Id}`).then(res => {
            if (res.Success) {
              _this.$Message['success']({
                background: true,
                content: res.Message
              });
              // 获取用户列表
              _this.getLoaderUserList();
            } else {
              _this.$Message['error']({
                background: true,
                content: res.Message
              });
            }
          }).catch(err => {
            console.log(err);
          })
        },
        onCancel: () => {

        }
      });
    },

    handleRowClick(row) {
      console.log(row);
    },
    // 页码改变的回调，返回改变后的页码
    onPageChange(value) {
      let _this = this;
      _this.pageIndex = value;
      // 获取用户列表
      _this.getLoaderUserList();
    },

    // 切换每页条数时的回调，返回切换后的每页条数
    onPageSizeChange(value) {
      let _this = this;
      _this.pageIndex = 1;
      _this.pageSize = value;
      // 获取用户列表
      _this.getLoaderUserList();
    },
  },
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
}
.app-header {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}
.header-title {
  line-height: 50px;
  font-size: 15px;
  color: rgb(150, 150, 150);
}
.header-view {
  overflow: hidden;
  padding-top: 9px;
}
.app >>> .ivu-table td {
  background-color: rgba(27, 44, 83, 0.5);
}
.app >>> .ivu-table {
  background-color: rgba(0, 0, 0, 0);
}
.app >>> .ivu-table-row:nth-child(odd) td {
  background-color: rgba(23, 46, 117, 0.5);
}
.app >>> .ivu-table-row:hover td {
  background-color: #123160;
  cursor: pointer;
}
.app >>> .ivu-table th {
  background-color: rgba(16, 27, 64, 0.7);
}
.app >>> .ivu-table-border th,
.app >>> .ivu-table-border td {
  border-right: 1px solid #2d8cf0;
}
.app >>> .ivu-table-border th:last-child,
.app >>> .ivu-table-border td:last-child {
  border-right: 0px solid #2d8cf0;
}
.app >>> .ivu-table-wrapper-with-border {
  border: 1px solid #2d8cf0;
  border-right: 0px solid rgb(1, 1, 1);
}
.app >>> .ivu-table th,
.app >>> .ivu-table td {
  border-bottom: 1px solid #2d8cf0;
}
.app >>> .ivu-table-cell-sort,
.app >>> .ivu-table-cell {
  color: rgb(220, 220, 220);
}
.app >>> .ivu-table-border:after {
  background-color: #2d8cf0;
}
.app >>> .ivu-table:before {
  height: 0;
}
.app >>> .ivu-page-prev,
.app >>> .ivu-page-next,
.app >>> .ivu-page-item {
  background-color: rgba(0, 0, 0, 0);
}
.app >>> .ivu-select-selection {
  background-color: rgba(27, 44, 83, 0.5);
  border: 1px solid #2d8cf0;
}
.app >>> .ivu-page-total,
.app >>> .ivu-page-options-elevator,
.app >>> .ivu-select-selected-value,
.app >>> .ivu-page-options-elevator input {
  color: rgb(220, 220, 220);
}
.app >>> .ivu-page-options-elevator input {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #2d8cf0;
}
.app >>> .ivu-input {
  background-color: #2e4395;
  color: rgb(220, 220, 220);
}
</style>